import { render, staticRenderFns } from "./configureCharts.vue?vue&type=template&id=4a0c955a&scoped=true"
import script from "./configureCharts.vue?vue&type=script&lang=js"
export * from "./configureCharts.vue?vue&type=script&lang=js"
import style0 from "./configureCharts.vue?vue&type=style&index=0&id=4a0c955a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a0c955a",
  null
  
)

export default component.exports